import {Container} from "@mantine/core";
import {useNavigate, useSearchParams} from "react-router-dom";
import {invoiceSelector, useGetInvoiceQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {ThemedPage} from "../../components/page/ThemedPage/ThemedPage";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {LoadingPage} from "../../components/page/LoadingPage/LoadingPage";
import {InvoiceProfile} from "../../components/profile/InvoiceProfile/InvoiceProfile"
import {useTranslation} from "react-i18next";
import {useAuth} from "../../providers/AuthProvider/AuthProvider";

type Props = {
  id?: string;
  database?: string
}

export const InvoiceProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const id = params.get("id") ?? undefined;
  const database = params.get("database") ?? undefined;

  const {t} = useTranslation(["common"])

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.invoice", "Invoice ") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <InvoiceProfilePage id={id} database={database}/>;
};

export const InvoiceProfilePage = (props: Props) => {
  const {id, database} = props;

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const selectInvoice = useMemo(() => {
    return invoiceSelector()
  }, []);

  const idQueryArg = useMemo(() => {
    return id ? {id: id, database: database} : skipToken
  }, [id, database])

  const {invoice, isFetching} = useGetInvoiceQuery(idQueryArg, {
    selectFromResult: (result) => ({
      invoice: selectInvoice(result),
      isFetching: result.isFetching
    })
  });

  if (!hasAccess("invoice_view")) {
    return <ErrorPage/>
  }

  if (isFetching) {
    return (
      <LoadingPage/>
    );
  }

  if (!invoice) {
    return (
      <ErrorPage
        message={t("common.entity.invoice", "Invoice") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return (
    <ThemedPage>
      {(classes) => (
        <Container className={classes.container} fluid={true} py="md">
          <InvoiceProfile invoice={invoice}/>
        </Container>
      )}
    </ThemedPage>
  );
};
